const bust = (url) => {
  const join = url.indexOf('?') === -1 ? '?' : '&';
  return `${url}${join}v=${Date.now()}`;
};

export default bust;
